import { StateService } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Observable, first } from "rxjs";
import {
  GlobalSearchResult,
  ITEMS_SHOWN_IF_EVERYWHERE,
  ITEMS_SHOWN_IF_NOT_EVERYWHERE,
  SearchFacetsOptions,
  SearchFacetsOptionsEnum,
} from "@webapp/search/models/search.models";
import { GlobalSearchMediatorService } from "@webapp/search/services/global-search.mediator.service";

@UntilDestroy()
@Component({
  selector: "search-results",
  templateUrl: "./search-results.component.html",
  styleUrls: ["./search-results.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsComponent implements OnInit {
  protected facetOptions$: Observable<SearchFacetsOptions[]>;
  protected currentFacet: SearchFacetsOptions;
  protected searchResults$: Observable<GlobalSearchResult[]>;
  public itemsLimit = ITEMS_SHOWN_IF_EVERYWHERE;

  constructor(private globalSearchMediatorService: GlobalSearchMediatorService, private stateService: StateService) {}

  public ngOnInit(): void {
    this.facetOptions$ = this.globalSearchMediatorService.facetToggleOptions$;
    this.globalSearchMediatorService.currentFacet$.pipe(untilDestroyed(this)).subscribe((currentFacet) => {
      this.currentFacet = currentFacet || SearchFacetsOptionsEnum.Everywhere;
      this.updateItemsLimit();
    });
    this.searchResults$ = this.globalSearchMediatorService.searchResults$;
  }

  public changeFacetToEverywhere(): void {
    this.globalSearchMediatorService.setCurrentFacet(SearchFacetsOptionsEnum.Everywhere);
  }

  protected viewAllResults(facet: SearchFacetsOptions): void {
    this.globalSearchMediatorService.searchTerm$.pipe(first()).subscribe((searchTerm) => {
      this.stateService.go("gtmhub.globalSearch", { facet, searchTerm });
    });
  }

  protected viewMoreResults(collectionName: SearchFacetsOptions): void {
    this.globalSearchMediatorService.setCurrentFacet(collectionName);
  }

  private updateItemsLimit(): void {
    this.itemsLimit = this.currentFacet !== SearchFacetsOptionsEnum.Everywhere ? ITEMS_SHOWN_IF_NOT_EVERYWHERE : ITEMS_SHOWN_IF_EVERYWHERE;
  }
}
